import React from 'react';
import classNames from 'classnames';

import { useBrowserWidth, useIsMobile } from '../../hooks';

import styles from './Grid.module.scss';

type Props = {
    notificationArea?: React.ReactNode;
    children: React.ReactNode;
    extraChildren?: React.ReactNode;
    className?: string;
}

const Grid: React.FC<Props> = ({
  notificationArea,
  children,
  extraChildren,
  className,
}) => {
  const { isMobile } = useIsMobile();
  const { browserWidthSize } = useBrowserWidth();

  return (
    <div className={styles.gridWrapper}>
      <div className={styles.grid}>
        {!(!extraChildren && notificationArea && browserWidthSize > 1280) && (
        <div>
          {notificationArea}
        </div>
        )}
        <div className={styles.gridBody}>
          <div className={classNames(styles.gridContent, {
            [styles.gridContentMobile]: isMobile && !extraChildren,
            [styles.gridContentFullWidth]: !isMobile && !extraChildren,
          },
          className)}
          >
            {children}
          </div>
          {extraChildren && (
          <div className={styles.gridExtraContent}>
            {extraChildren}
          </div>
          )}
          {!extraChildren && notificationArea && !isMobile && browserWidthSize > 1280 && (
            <div className={classNames(styles.gridExtraContent, styles.smallNotificationsWidth)}>
              {notificationArea}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Grid;
